import { createFileRoute } from "@tanstack/react-router";
import AlbumsDashboard from "./-components/AlbumsDashboard";

export const Route = createFileRoute("/audiolab/releases/")({
  component: AlbumsDashboard,
  head: () => ({ meta: [{ title: "Releases | Audiolab | Lutely" }] }),
});
